export default "__VITE_ASSET__5k9dbO38__"